// extracted by mini-css-extract-plugin
module.exports = {"branch":"Branch_branch__3Zact"};